//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fetchTool from '../../../../common/tool/fetchTool'
import platform from "@/config/platform";
//引入VueOfficeDocx组件
import VueOfficeDocx from '@vue-office/docx'
//引入相关样式
import '../../../../assets/css/view.css'
//引入VueOfficeExcel组件
import VueOfficeExcel from '@vue-office/excel'
//引入相关样式
import '@vue-office/excel/lib/index.css'
//引入VueOfficePdf组件
import VueOfficePdf from '@vue-office/pdf'
import { Toast, Loading } from 'vant'
import CryptoJS from "crypto-js";
import { fetch } from "@/page/index";

export default {
  name: "FileListModel",
  props: {
    docData: { type: Array, default: () => [] },
    /** 是否显示删除（仅业务页在可编辑场景下传 true） */
    showDelete: { type: Boolean, default: false },
  },
  data() {
    return {
      showFileModel: false,
      showPreview: false,
      file: {
        previewFileUrl: '',
        previewFileName: '',
        previewFileSize: 0,
        previewFileType: null,
      },
      docEditor: null,
      config: null,
      base64ImageData: '', // 存储图片的base64数据
      isImage: false, // 是否为图片类型
      imageError: false, // 图片加载是否出错
    }
  },
  components: {
    VueOfficeDocx,
    VueOfficeExcel,
    VueOfficePdf,
  },
  beforeDestroy() {
    if (!!this.docEditor) {
      this.docEditor.destroyEditor();
      this.docEditor = null;
    }
  },
  computed: {
    editorKey() {
      return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    },
    // 支持的图片格式
    supportedImageFormats() {
      return ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'];
    }
  },
  mounted() {
  },
  methods: {
    closeFilePreview() {
      if (!!this.docEditor) {
        this.docEditor.destroyEditor();
        this.docEditor = null;
      }
      this.showPreview = false;
      this.base64ImageData = '';
      this.isImage = false;
      this.imageError = false;
    },
    formatFileSize(size) {
      if (!size) return '';
      if (size < 1024) return size + ' B';
      if (size < 1024 * 1024) return (size / 1024).toFixed(2) + ' KB';
      return (size / (1024 * 1024)).toFixed(2) + ' MB';
    },
    openFile(path) {
      window.open(path);
    },
    onDeleteClick(file) {
      this.$emit('delete-file', file)
    },

    doPreview(row) {
      const { fileUrl, fileName, fileSize, suffixName, id } = row;

      this.file.previewFileUrl = fileUrl;
      this.file.previewFileName = fileName;
      this.file.previewFileSize = fileSize;
      this.file.previewFileType = suffixName && suffixName.toLowerCase();
      this.imageError = false;
      this.isImage = this.supportedImageFormats.includes(this.file.previewFileType);

      this.$nextTick(() => {
        this.showPreview = true;
        if (this.isImage) {
          this.convertImageToBase64(id);
        } else {
          this.loadOnlyOfficeAPI(row);
        }
      })
    },

    // 将图片转换为base64
    convertImageToBase64(id) {
      this.base64ImageData = '';
      fetch.v2FileGetFileToBase64({
        id: id
      }).then(resView => {
        this.base64ImageData =  "data:image/jpeg;base64," + resView.data
      })
    },

    // 处理图片加载错误
    handleImageError() {
      this.imageError = true;
      this.base64ImageData = '';
      Toast("图片加载失败，点击打开原文件");
    },

    async loadOnlyOfficeAPI(obj) {
      let jsId = 'oo_js_main';
      let onlyOfficeScriptTag = document.getElementById(jsId);
      if (!!!onlyOfficeScriptTag) {
        let _url = window.location.origin + '/web-apps/apps/api/documents/api.js'
        this.loadScript(_url, jsId).then(() => {
          this.initDocEditor(obj);
        });
      } else {
        this.initDocEditor(obj);
      }
    },

    loadScript(url, jsId) {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        script.async = true;
        script.id = jsId
        script.onload = () => resolve(script);
        script.onerror = () => reject(new Error(`Failed to load script at ${url}`));
        document.head.appendChild(script);
      });
    },

    onAppReady(event) {
      console.log("ONLYOFFICE Document Editor is ready");
      this.$forceUpdate();
    },
    onDocumentReady(event) {
      console.log("Document is loaded");
    },
    onRequestClose(event) {
      console.log("Document is closed");
    },

    initDocEditor(obj) {
      console.log(obj.fileId);
      let url = `${platform.url.fileServer}/v2/file/onlyoffice/view`;
      fetchTool.post(url + "?fileId=" + obj.id, {}).then(res => {
        // console.log(res);
          // 修正域名替换逻辑
          res.document.url = res.document.url.replace("https://srm.schkzy.com","https://m-srm.schkzy.com");
          res.editorConfig.callbackUrl = res.editorConfig.callbackUrl.replace("https://srm.schkzy.com","https://m-srm.schkzy.com");
          console.log(res);
        this.config = res;
        this.config['width'] = "100%";
        this.config['height'] = "100%";
        this.config['type'] = "mobile";
        let defaultEvents = {
          "onAppReady": this.onAppReady,
          "onDocumentReady": this.onDocumentReady,
          "onRequestClose": this.onRequestClose
        };
        let _plugins = {
          pluginsData: [window.location.origin + '/plugins/plugin-contract/config.json']
        }

        this.config.editorConfig['plugins'] = _plugins
        this.config.editorConfig['permissions'] = {
          download: false
        }
        if (!!obj.events) {
          this.config['events'] = { ...defaultEvents, ...obj.events };
        } else {
          this.config['events'] = defaultEvents;
        }
        console.log("onlyoffice config:", this.config)
        if (typeof DocsAPI !== 'undefined') {
          this.docEditor = new DocsAPI.DocEditor(this.editorKey, this.config);
        } else {
          Toast("DocsAPI is not defined after loading.");
        }
      }, () => {
        let errMsg = "Error fetching data from server."
        Toast(errMsg);
      })
    },
  },
};



// WEBPACK FOOTER //
// ./src/page/srm/pendingApproval/components/FileListModel.vue